module.exports = __webpack_public_path__ + "static/shopify-5701b3f808f01021d3986a112e384d67.png";